import { APP } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  mini: false,
  profile: {
    originalTenant: '--ANONYMOUS--',
  },
  fetchProfileStatus: undefined,
  clients: [],
  fetchClientsStatus: undefined,
  tenant: undefined,
  client: null,
  selectClientStatus: undefined,
  segmentId: undefined,
  registerStatus: undefined,
  registerError: undefined,
  addClientStatus: undefined,
  addClientError: undefined,
  deleteClientStatus: undefined,
  deleteClientError: undefined,
  datasets: [],
  fetchDatasetsStatus: undefined,
  fetchDatasetsError: undefined,
  datasetId: undefined,
  selectedDatasetIds: [],
  notifications: [],
  message: null,
  flyoverPinStatus: CONSTANTS.FLYOVER.UNPINNED,
  flyoverOpenStatus: CONSTANTS.FLYOVER.CLOSE,
  submitFeedbackStatus: null,
  submitFeedbackError: null,
  presignedUrl: null,
  presignedUrlStatus: null,
  presignedUrlError: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APP.TOGGLE_MENU:
      return {
        ...state,
        mini: !state.mini,
      };
    case APP.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case APP.SET_TENANT:
      return {
        ...state,
        tenant: action.payload,
      };
    case APP.SET_CLIENT:
      return {
        ...state,
        client: action.payload,
      };
    case APP.FETCH_PROFILE:
      return {
        ...state,
        fetchProfileStatus: CONSTANTS.API.STARTED,
      };
    case APP.ADD_CLIENT_FAILED:
      return {
        ...state,
        addClientStatus: CONSTANTS.API.FAILED,
        addClientError: action.payload.message || 'Client creation failed',
      };
    case APP.ADD_CLIENT_SUCCEEDED:
      return {
        ...state,
        addClientStatus: CONSTANTS.API.SUCCEEDED,
        addClientError: undefined,
      };
    case APP.ADD_CLIENT:
      return {
        ...state,
        addClientStatus: CONSTANTS.API.STARTED,
        addClientError: undefined,
      };
    case APP.DEL_CLIENT_FAILED:
      return {
        ...state,
        deleteClientStatus: CONSTANTS.API.FAILED,
        deleteClientError: action.payload.message || 'Client deletion failed',
      };
    case APP.DEL_CLIENT_SUCCEEDED:
      return {
        ...state,
        deleteClientStatus: CONSTANTS.API.SUCCEEDED,
        deleteClientError: undefined,
      };
    case APP.DEL_CLIENT:
      return {
        ...state,
        deleteClientStatus: CONSTANTS.API.STARTED,
        deleteClientError: undefined,
      };
    case APP.REGISTER_FAILED:
      return {
        ...state,
        registerStatus: CONSTANTS.API.FAILED,
        registerError: action.payload.message || 'User registration failed',
      };
    case APP.REGISTER_SUCCEEDED:
      return {
        ...state,
        registerStatus: CONSTANTS.API.SUCCEEDED,
        registerError: undefined,
      };
    case APP.REGISTER:
      return {
        ...state,
        registerStatus: CONSTANTS.API.STARTED,
        registerError: undefined,
      };
    case APP.FETCH_PROFILE_SUCCEEDED:
      return {
        ...state,
        profile: {
          ...action.payload,
          originalRole: state.role,
        },
        fetchProfileStatus: CONSTANTS.API.SUCCEEDED,
      };
    case APP.FETCH_PROFILE_FAILED:
      return {
        ...state,
        fetchProfileStatus: CONSTANTS.API.FAILED,
      };
    case APP.FETCH_CLIENTS:
      return {
        ...state,
        fetchClientsStatus: CONSTANTS.API.STARTED,
      };
    case APP.FETCH_CLIENTS_SUCCEEDED:
      return {
        ...state,
        clients: action.payload,
        fetchClientsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case APP.FETCH_CLIENTS_FAILED:
      return {
        ...state,
        fetchClientsStatus: CONSTANTS.API.FAILED,
      };
    case APP.FETCH_DATASETS:
      return {
        ...state,
        fetchDatasetsStatus: CONSTANTS.API.STARTED,
      };
    case APP.FETCH_DATASETS_SUCCEEDED:
      return {
        ...state,
        datasets: action.payload,
        fetchDatasetsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case APP.FETCH_DATASETS_FAILED:
      return {
        ...state,
        fetchDatasetsStatus: CONSTANTS.API.FAILED,
      };
    case APP.SET_DATASET_ID:
      return {
        ...state,
        datasetId: action.payload,
      };
    case APP.SELECT_CLIENT:
      return {
        ...state,
        selectClientStatus: CONSTANTS.API.STARTED,
      };
    case APP.SELECT_CLIENT_SUCCEEDED:
      return {
        ...state,
        selectClientStatus: CONSTANTS.API.SUCCEEDED,
      };
    case APP.SELECT_CLIENT_FAILED:
      return {
        ...state,
        selectClientStatus: CONSTANTS.API.FAILED,
      };
    case APP.SET_SEGMENT_ID:
      return {
        ...state,
        segmentId: action.payload,
      };
    case APP.SELECT_DATASET_ID:
      return {
        ...state,
        selectedDatasetIds: [...state.selectedDatasetIds, action.payload],
      };
    case APP.DESELECT_DATASET_ID:
      return {
        ...state,
        selectedDatasetIds: state.selectedDatasetIds.filter((datasetId) => datasetId !== action.payload),
      };
    case APP.DESELECT_ALL_DATASET_IDS:
      return {
        ...state,
        selectedDatasetIds: [],
      };
    case APP.ENQUEUE_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };
    case APP.DEQUEUE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.slice(1),
      };
    case APP.FLASH_MESSAGE:
      return {
        ...state,
        message: action.payload,
      };
    case APP.HIDE_MESSAGE:
      return {
        ...state,
        message: null,
      };
    case APP.SET_FLYOVER_OPEN_STATUS:
      return {
        ...state,
        flyoverOpenStatus: action.payload,
      };
    case APP.SET_FLYOVER_PIN_STATUS:
      return {
        ...state,
        flyoverPinStatus: action.payload,
      };
    case APP.SUBMIT_FEEDBACK:
      return {
        ...state,
        submitFeedbackStatus: CONSTANTS.API.STARTED,
      };
    case APP.SUBMIT_FEEDBACK_SUCEEDED:
      return {
        ...state,
        submitFeedbackStatus: CONSTANTS.API.SUCCEEDED,
      };
    case APP.SUBMIT_FEEDBACK_FAILED:
      return {
        ...state,
        submitFeedbackStatus: CONSTANTS.API.FAILED,
      };
    case APP.GET_PRESIGNED_URL:
      return {
        ...state,
        presignedUrlStatus: CONSTANTS.API.STARTED,
      };
    case APP.GET_PRESIGNED_URL_SUCCEEDED:
      return {
        ...state,
        presignedUrl: action.payload,
        presignedUrlStatus: CONSTANTS.API.SUCCEEDED,
      };
    case APP.GET_PRESIGNED_URL_FAILED:
      return {
        ...state,
        presignedUrlStatus: CONSTANTS.API.FAILED,
      };

    default:
      return state;
  }
};
